import React from 'react'

const Footer = () => {
  return (
    <div className="footer mt-2">
    Powered by &copy; Data Team
  </div>
  )
}

export default Footer